import ByteBuffer from './byteBuffer'
import emitter from './emitter'
import TYPE from './emitType'
import { keys } from 'lodash-es'
import { getCache, JSONParse, JSONStringify } from './utils'
import dayjs from 'dayjs'

// 登录
export function sendLogin() {
  const { mine, sesskey } = getCache()
  const gp = 0
  const type = 1111 // 登录的类型, 1111 聊天方式登录

  return ByteBuffer.eWriteStart(1000)
    .writeInt32(mine.id)
    .eWriteUTF8String(sesskey)
    .writeInt32(gp)
    .writeInt32(type)
    .writeInt32(1) // web 登录标志 1 h5
    .eWriteEnd()
}

// 发送准备基础信息
export function sendReady() {
  const { mine } = getCache()

  return ByteBuffer.eWriteStart(16000)
    .eWriteUTF8String(JSONStringify(mine))
    .eWriteEnd()
}

// 获取对话列表
export function getTalkList() {
  return ByteBuffer.eWriteStart(16001)
    .eWriteEnd()
}

// 获取接管列表
export function getTalkOver() {
  return ByteBuffer.eWriteStart(16002)
    .eWriteEnd()
}

// 获取历史记录
export function getHistory(toId) {
  return ByteBuffer.eWriteStart(16100)
    .writeInt32(toId)
    .eWriteEnd()
}

// 发送消息
export function sendChat({ mine, to }) {
  const { content } = mine
  const { id } = to
  return ByteBuffer.eWriteStart(16101)
    .eWriteUTF8String('ext') // 消息附带的其他信息, 先约定固定字符串
    .writeInt32(id) // 对方 id
    .eWriteUTF8String(content)
    .eWriteEnd()
}

// 发送消息已读
export function sendRead(messageId) {
  return ByteBuffer.eWriteStart(16102)
    .eWriteUTF8String(messageId)
    .eWriteEnd()
}

// [客服] 清除与某个人的聊天消息 (调试清理脏数据)
export function cleanChat(toId) {
  return ByteBuffer.eWriteStart(16103)
    .writeInt32(toId)
    .eWriteEnd()
}

// 客服接管玩家
export function sendTakeOverUser(id) {
  return ByteBuffer.eWriteStart(16200)
    .writeInt32(id)
    .eWriteEnd()
}

// 置顶/取消置顶
export function sendSetTop(id, state) {
  return ByteBuffer.eWriteStart(16201)
    .writeInt32(id)
    .writeInt32(state)
    .eWriteEnd()
}

// 正在输入
export function sendOnTyping(id) {
  return ByteBuffer.eWriteStart(16203)
    .writeInt32(id)
    .eWriteEnd()
}

// 发送心跳检测
export function sendHeartCheck() {
  return ByteBuffer.eWriteStart(10006)
    .eWriteEnd()
}

// 撤回消息
export function sendRecallMessage(messageId) {
  return ByteBuffer.eWriteStart(16105)
    .eWriteUTF8String(messageId)
    .eWriteEnd()
}

// 添加好友
export function sendAddTalk(id) {
  return ByteBuffer.eWriteStart(16106)
    .writeInt32(id)
    .eWriteEnd()
}

// 测试消息
export function sendTest() {
  return ByteBuffer.eWriteStart(16199)
    .eWriteEnd()
}

// 新开发的 ws 服务器，由 ws 服务器已经处理游戏服发过来的 tcp 包的分包或粘包问题，ws 客户端处理分包或粘包，收到就是一个完整的包
export const onMessage = (event) => {
  // 执行函数
  handleMessage(ByteBuffer.wrap(event.data, 'binary', ByteBuffer.LITTLE_ENDIAN))
}

// export const onMessage = (() => {
//   const socketBuff = new ArrayBuffer(1024 * 32)
//   // 可写的下标
//   let socketWriteLen = 0
//   // 未处理可读的下标
//   let socketReadPos = 0
//   return (event) => {
//     // 接收消息并存好
//     new Uint8Array(socketBuff, socketWriteLen, event.data.byteLength).set(new Uint8Array(event.data))
//     socketWriteLen += event.data.byteLength
//     // 去判断是否有完整的包并处理
//     // eslint-disable-next-line no-constant-condition
//     while (true) {
//       // 检查包头的长度
//       if (socketWriteLen < 6) {
//         break
//       }
//       // 检查包体的长度
//       const headerBuffer = new DataView(socketBuff, socketReadPos, 6)
//       const packetLen = 6 + headerBuffer.getUint16(2, true)
//       if (socketWriteLen < packetLen) {
//         break
//       }
//       // 构造一个新的buffer用于方法中使用,将socket收到的buffer复制到该buffer中
//       const packetBuffer = new ArrayBuffer(packetLen)
//       new Uint8Array(packetBuffer).set(new Uint8Array(socketBuff, socketReadPos, packetLen))
//       // 记录已经使用了到哪个位置
//       socketReadPos += packetBuffer.byteLength
//       // 执行函数
//       handleMessage(ByteBuffer.wrap(packetBuffer, 'binary', ByteBuffer.LITTLE_ENDIAN))
//       // 判断是否还有其他未处理完的数据
//       if (socketReadPos === socketWriteLen) {
//         socketWriteLen = 0
//         socketReadPos = 0
//         // 全部读完了，可以直接跳出了
//         break
//       }
//     }
//   }
// })()

// 处理消息数据
function handleMessage(bb) {
  // 跳过 qs body长度
  bb.offset += 4
  const cmd = bb.readUint16()
  if(cmd != 10006)
    console.log('cmd =>', cmd)
  switch (cmd) {
    // 登录
    case 1000:
      onLogin(bb)
      break
    // 准备基础信息
    case 16000:
      onReady(bb)
      break
    // 对话列表
    case 16001:
      onTalkList(bb)
      break
    // 接管列表
    case 16002:
      onTakeOverList(bb)
      break
    // 分配给我的客服
    case 16003:
      onCustomerService(bb)
      break
    // 历史记录
    case 16100:
      onHistory(bb)
      break
    // 收到消息
    case 16101:
      onChat(bb)
      break
    // 已读消息
    case 16102:
      onRead(bb)
      break
    // 客服收到刷新未读数量的消息
    case 16104:
      onUnreadNum(bb)
      break
    // 撤回消息
    case 16105:
      onRecallMessage(bb)
      break
    // 查找用户
    case 16106:
      onAddTalk(bb)
      break
    // 接管用户结果
    case 16200:
      onTakeOverResult(bb)
      break
    // 设置/取消置顶结果
    case 16201:
      onSetTop(bb)
      break
    case 16203:
      onTyping(bb)
      break;
  }
}

// 登录
const onLogin = (() => {
  const msgMap = {
    '3': 'Your account is logged in another place',
    '8': 'The service is restarting. Please wait',
    'default': 'Login failed'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      emitter.emit(TYPE.LOGIN_SUCCESS)
    } else {
      emitter.emit(TYPE.LOGIN_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

// 准备用户信息数据
const onReady = (() => {
  const msgMap = {
    '-1': 'username not found',
    '-2': 'avatar not found',
    '-3': 'id not found',
    '-4': 'nick not found',
    '-5': 'customer service list not found',
    '-6': 'rand customer service not found',
    'default': 'Update your own info fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      emitter.emit(TYPE.READY_SUCCESS)
    } else {
      emitter.emit(TYPE.READY_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

const formatLastSendTime = (lastSendTime) => {
  return lastSendTime ? dayjs(lastSendTime * 1000).format('HH:mm') : ''
}

const getFriendList = (content, t) => {
  // 0 更新全部 1 新加 2 删除 3 更新某个人信息
  const type = content.readInt32()
  // 当前第几批数据
  const current = content.readInt32()
  // 一共有几批数据
  const pages = content.readInt32()
  // 当前批有多少条数据
  const len = content.readInt32()
  const list = [...keys(Array(len))].map(() => {
    // 玩家 id
    const id = content.readInt32()
    // 玩家信息
    const userInfo = JSONParse(content.eReadUTF8String())
    // 未读条数
    const unread = content.readInt32()
    // 0 不在线, 1 在线
    const status = content.readInt32() ? 'online' : 'offline'
    // 最后消息发送时间
    const lastSendTime = content.readInt32()
    // 最后消息发送时间字符串
    const lastSendTimeStr = formatLastSendTime(lastSendTime)
    // 是否置顶
    const isTop = t === 'talk' ? content.readInt32() : 0
    // 是否Vip
    const isVip = t === 'talk' ? content.readInt32() : 0
    return {
      id,
      unread,
      status,
      ...userInfo,
      lastSendTime,
      lastSendTimeStr,
      isTop,
      isVip
    }
  })
  return {
    type,
    list,
    isStart: current === 1,
    isEnd: current === pages
  }
}

// 对话列表
const onTalkList = (content) => {
  emitter.emit(TYPE.GET_TALK_LIST, getFriendList(content, 'talk'))
}

// 接管列表
const onTakeOverList = (content) => {
  emitter.emit(TYPE.GET_TAKE_OVER_LIST, getFriendList(content, 'takeOver'))
}

// 分配给我的客服
const onCustomerService = (() => {
  const msgMap = {
    'default': 'There is no customer service in this period'
  }
  return (content) => {
    const id = content.readInt32()
    const { mid, name, icon } = JSONParse(content.eReadUTF8String())
    const userInfo = { username: name, avatar: icon, id: mid }
    if (id === 0) {
      emitter.emit(TYPE.GET_CUSTOMER_SERVICE_FAIL, { code: id, msg: msgMap[id] ?? msgMap['default'] })
    } else {
      emitter.emit(TYPE.GET_CUSTOMER_SERVICE_SUCCESS, { id, userInfo })
    }
  }
})()

// 历史记录
const onHistory = (() => {
  const msgMap = {
    '-1': 'The player is not in your conversation',
    '-2': 'Customer service is not in your conversation',
    'default': 'Get History Fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === -1 || err === -2) {
      emitter.emit(TYPE.GET_HISTORY_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    } else {
      const toId = content.readInt32()
      const userInfo = JSONParse(content.eReadUTF8String())
      const len = content.readInt32()
      const list = [...keys(Array(len))].map(() => readContent(content))
      emitter.emit(TYPE.GET_HISTORY_SUCCESS, {
        toId,
        userInfo,
        list
      })
    }
  }
})()

// 收到自己或者对方的消息
const onChat = (() => {
  const msgMap = {
    '-1': 'Wrong receive ID',
    '-2': 'The length of the sender\'s message is too long and cannot be greater than 512 bytes',
    '-3': 'The content sent is too long and cannot be greater than 512 bytes',
    '-4': 'You can\'t send messages to yourself',
    '-5': 'Only chat with players',
    '-6': 'Customer service can\'t initiate chatting with players',
    '-7': 'Players can only chat with customer service',
    '-9': 'Only chat with the designated customer service',
    'default': 'Send fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      const data = readContent(content)
      emitter.emit(TYPE.CHAT, data)
    } else {
      emitter.emit(TYPE.SEND_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

// 已读消息
const onRead = (() => {
  const msgMap = {
    '-1': 'The message could not be found',
    '-2': 'The message is not for yourself and cannot be read',
    '-3': 'The message is already read',
    'default': 'Read fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      const messageId = content.eReadUTF8String()
      emitter.emit(TYPE.READ_MESSAGE_SUCCESS, { messageId })
    } else {
      emitter.emit(TYPE.READ_MESSAGE_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

// 设置未读消息数量
const onUnreadNum = (content) => {
  const len = content.readInt32()
  const list = [...keys(Array(len))].map(() => {
    const userId = content.readInt32()
    const unread = content.readInt32()
    // 最后消息发送时间
    const lastSendTime = content.readInt32()
    // 最后消息发送时间字符串
    const lastSendTimeStr = formatLastSendTime(lastSendTime)
    return {
      userId,
      unread,
      lastSendTime,
      lastSendTimeStr
    }
  })
  emitter.emit(TYPE.UNREAD_NUM, { list })
}

// 撤回消息
const onRecallMessage = (() => {
  const msgMap = {
    '-1': 'The message id invalid',
    '-2': 'You are not the sender',
    '-3': 'The message has been over 600 seconds',
    'default': 'Recall Message fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      const messageId = content.eReadUTF8String()
      emitter.emit(TYPE.RECALL_MESSAGE_SUCCESS, { messageId })
    } else {
      emitter.emit(TYPE.RECALL_MESSAGE_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

// 添加用户结果
const onAddTalk = (() => {
  const msgMap = {
    '-1': 'Incorrect user ID',
    '-2': 'The player already has customer service. You can talk directly or take over him',
    '-3': 'The user cannot be found. The user needs to log in to the game to chat with him',
    'default': 'Add Talk fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      const userId = content.readInt32()
      emitter.emit(TYPE.ADD_TALK_SUCCESS, { userId })
    } else {
      emitter.emit(TYPE.ADD_TALK_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

// 接管用户结果
const onTakeOverResult = (() => {
  const msgMap = {
    '-1': 'The user is already in the conversation',
    '-2': 'Can only take over players',
    'default': 'Take over fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      const userId = content.readInt32()
      emitter.emit(TYPE.GET_TAKE_OVER_SUCCESS, { userId })
    } else {
      emitter.emit(TYPE.GET_TAKE_OVER_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

// 设置/取消置顶结果
const onSetTop = (() => {
  const msgMap = {
    '-1': 'This user is not in your conversation list',
    'default': 'Set top fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      const userId = content.readInt32()
      const type = content.readInt32()
      emitter.emit(TYPE.SET_TOP_SUCCESS, { userId, type })
    } else {
      emitter.emit(TYPE.SET_TOP_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

const onTyping = (() => {
  const msgMap = {
    '-1': 'This user is not in your conversation list',
    'default': 'Ontyping fail'
  }
  return (content) => {
    const err = content.readInt32()
    if (err === 0) {
      const userId = content.readInt32()
      emitter.emit(TYPE.TYPING_SUCCESS, { userId })
    } else {
      emitter.emit(TYPE.TYPING_FAIL, { code: err, msg: msgMap[err] ?? msgMap['default'] })
    }
  }
})()

// 读取聊天内容
const readContent = (data) => {
  const { mine } = getCache()
  // 消息 id
  const messageId = data.eReadUTF8String()
  // 发送者 id
  const sendId = data.readInt32()
  // 消息附带的其他信息, 先约定固定字符串
  const ext = data.eReadUTF8String()
  // 接收者 id
  const getId = data.readInt32()
  // 聊天内容
  const content = data.eReadUTF8String()
  // 时间戳
  const timestamp = data.readInt32() * 1000
  // 状态 0 未读, 1 已读
  const state = data.readInt32()
  // 是否为自己的消息
  const isMine = sendId === mine.id

  return {
    messageId,
    sendId,
    ext,
    getId,
    id: isMine ? getId : sendId, // 显示窗口的 id
    type: 'friend',
    content,
    mine: isMine,
    timestamp,
    state
  }
}
